module.exports = __webpack_public_path__ + "img/lg_ring_r_i_null_0.8bdea8cb.png";